import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';

import serviceImg1 from '../../assets/img/service/service-2-1.jpg';
import serviceImg2 from '../../assets/img/service/service-2-2.jpg';
import serviceImg3 from '../../assets/img/service/service-2-3.jpg';
import serviceImg4 from '../../assets/img/service/service-2-4.jpg';
import serviceImg5 from '../../assets/img/service/service-2-5.jpg';
import serviceImg6 from '../../assets/img/service/service-2-6.jpg';

const Service = () => {
  return (
    <div id="it-service" className="it-service-2-area  grey-bg-3 pt-120 pb-90">
      <div className="container">
        <div className="it-service-2-title-wrapper mb-65">
          <div className="row align-items-end">
            <div className="col-lg-6 col-md-7">
              <SectionTitle
                itemClass="it-service-2-title-box"
                subTitle="خدماتنا"
                title="الخدمات التي نقدمها"
              />
            </div>
            <div className="col-lg-6 col-md-5">
              <div className="it-service-2-button text-md-start">
                <Link className="it-btn-theme" to="/service">
                  <Button btnText="عرض جميع الخدمات" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleServiceTwo
              serviceImage={serviceImg1}
              title="يزرع"
              description="لا يوجد تزاوج. ما لم تعميهم الشهوة، فإنهم لا يخرجون، إنهم مخطئون الذين يقومون بواجبهم "
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleServiceTwo
              serviceImage={serviceImg2}
              title="races"
              description="لا يوجد تزاوج. ما لم تعميهم الشهوة، فإنهم لا يخرجون، إنهم مخطئون الذين يقومون بواجبه"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleServiceTwo
              serviceImage={serviceImg3}
              title="Teeth whitening"
              description="لا يوجد تزاوج. ما لم تعميهم الشهوة، فإنهم لا يخرجون، إنهم مخطئون الذين يقومون بواجبه"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".8s"
          >
            <SingleServiceTwo
              serviceImage={serviceImg4}
              title="Teeth Removal"
              description="لا يوجد تزاوج. ما لم تعميهم الشهوة، فإنهم لا يخرجون، إنهم مخطئون الذين يقومون بواجبه"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1s"
          >
            <SingleServiceTwo
              serviceImage={serviceImg5}
              title="Tooth Checkup"
              description="لا يوجد تزاوج. ما لم تعميهم الشهوة، فإنهم لا يخرجون، إنهم مخطئون الذين يقومون بواجبه"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.2s"
          >
            <SingleServiceTwo
              serviceImage={serviceImg6}
              title="Straighten Teeth"
              description="لا يوجد تزاوج. ما لم تعميهم الشهوة، فإنهم لا يخرجون، إنهم مخطئون الذين يقومون بواجبه"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
